module.exports = __webpack_public_path__ + "img/neck opening.c5433354.png";